import { useLocation } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet-async";

import { Button } from '@govtechsg/sgds-react/Button'
import { SgdsMasthead } from '@govtechsg/sgds-masthead-react'

import Navbar from '../../Components/NavbarComponent'
import FooterComponent from '../../Components/FooterComponent'
import SideNavComponent from '../../Components/SideNavComponent'
import MastheadAnnouncement from '../../Components/MastheadAnnouncement'

import arrowleft from '../../assets/icons/arrow-left.svg'
import arrowright from '../../assets/icons/arrow-right.svg'

// import basemapImg from '../res/basemap.png'
import advminimap from '../../res/advminimap.png'
import minimap from '../../res/minimap.png'
import staticMap from '../../res/static_map_screenshot.png'

// import reverseGeocode from '../res/reverseGeocode.png'

import city from '../../images/city.jpg'
import night from '../../images/Night.jpg'
import grey from '../../images/Grey.jpg'
import classic from '../../images/classic.jpg'
// import orthophoto from '../images/Orthophoto.jpg'
// import staticmapImg from '../images/staticmap.jpeg'


// Component
import AuthenticationComponent from '../../Components/AuthenticationComponent'
import PopulationComponent from '../../Components/PopulationComponent'

import Endpoint from '../../Components/Endpoint';
import endpointsData from '../../json/sampleEndpts.json';

const MapsServices = () => {
  const location = useLocation()
  // console.log(location, 'location')
  const [customEndpoints, setEndpoints] = useState([]);

  useEffect(() => {
    setEndpoints(endpointsData); // Set the endpoints from the imported JSON data
  }, []);

  const generateCodeSnippet = (id, endpoint) => {
    // You can customize the code generation logic based on your requirements

    let pythonCode, jsCode;
    // console.log(String(endpoint))

    if(id==="authentication" || id==="staticMap"){
      pythonCode=`import requests
import os
      \nurl = "https://www.onemap.gov.sg${endpoint}"
      \npayload = {
        "email": os.environ['ONEMAP_EMAIL'],
        "password": os.environ['ONEMAP_EMAIL_PASSWORD']
      }
      \nresponse = requests.request("POST", url, json=payload)
      \nprint(response.text)`;

      jsCode=`const data = JSON.stringify({
        "email": process.env.ONEMAP_EMAIL,
        "password": process.env.ONEMAP_EMAIL_PASSWORD
      });
      \nconst xhr = new XMLHttpRequest();
      \nxhr.addEventListener("readystatechange", function () {
        if (this.readyState === this.DONE) {
        }
      });
      \nxhr.open("POST", "https://www.onemap.gov.sg${endpoint}");
      \nxhr.setRequestHeader("Content-Type", "application/json");
      \nxhr.send(data);`;

    }else if(id==="search"){
      pythonCode = `import requests
      \nurl = "https://www.onemap.gov.sg${endpoint}"
      \nresponse = requests.request("GET", url, headers=headers)
      \nprint(response.text)`;

      jsCode = `const data = JSON.stringify(false);
      \nconst xhr = new XMLHttpRequest();
      \nxhr.addEventListener("readystatechange", function () {
        if (this.readyState === this.DONE) {
        }
      });
      \nxhr.open("GET", "https://www.onemap.gov.sg${endpoint}");
      \nxhr.send(data);`;

    }else{
      pythonCode = `import requests
      \nurl = "https://www.onemap.gov.sg${endpoint}"
      \nheaders = {"Authorization": "**********************"}
      \nresponse = requests.request("GET", url, headers=headers)
      \nprint(response.text)`;
      jsCode = `const data = JSON.stringify(false);
      \nconst xhr = new XMLHttpRequest();
      \nxhr.addEventListener("readystatechange", function () {
        if (this.readyState === this.DONE) {
        }
      });
      \nxhr.open("GET", "https://www.onemap.gov.sg${endpoint}");
      \nxhr.setRequestHeader("Authorization", "**********************");
      \nxhr.send(data);`;
    }

    return { pythonCode, jsCode };
  };

  const endpointreturn = (id)=>{
    const endpt_elem = customEndpoints.find(customEndpoint => customEndpoint.page_section === id);
    // console.log(id,endpt_elem)
    const { pythonCode, jsCode} = generateCodeSnippet(id, endpt_elem.sampleRequest);
    
    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };

  }


  //  console.log(location)
  const { state } = location

  const [activeKey, setActiveKey] = useState('')
  // const [activeLinkKey, setActiveLinkKey] = useState('')
  // const clickLink = (key) => {
  //   setActiveLinkKey(key)
  // }
  
  const clickButton = (key) => {
    activeKey === key ? setActiveKey('') : setActiveKey(key)
  }
  //  const clickButtonLink = (key) => {
  useEffect(() => {
    if (state === null) {
      clickButton('0')
    } else {
      // clickButton(state.selectedID.toString())
      // clickButton('3')
      console.log(location, 'location')
      clickButton(location.state.toString())
    }
  }, [state])

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

	return (
    <>
      <Helmet>
        <title>Basemap, Minimap, Advanced Minimap, and Static Map Tools | OneMap API</title>
        <meta
          name="description"
          content="Explore OneMap's wide range of geospatial mapping tools including Basemaps with various color schemes, Minimap, Advanced Minimap with multiple markers, and Static Map for creating maps with designated markers, lines, and polygons. Easily embed these maps on websites or use as URLs. Discover demos and sample codes for seamless integration with Singapore's geospatial data platform."
        />
      </Helmet>
      <MastheadAnnouncement/>
      <Navbar />
      <div className='row qx-0 mb-5 position-relative'>
        {/* Button to collapse SideNav in mobile view */}
      <div className='col-1 d-md-none d-inline'>
        <div
          className="btn btn-primary d-md-none position-fixed sideBarBtn"
          onClick={(e)=>{handleCollapse(); 
            if(isCollapsed){
              window.scrollTo(0,0);
            }
          }}
        >
          Show Side Bar
        </div>
      </div>
        
      <div className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? 'collapse' : ''
          }`}
      // <div className='d-none d-md-block col-12 col-md-3 qx-0 px-3'
        style={{
          // float: 'left',
          // width: '25%',
          // paddingLeft: '30px',
          // backgroundColor: 'cyan',
          // border: '2px solid blue',
          // borderRadius: '10px',
          // marginLeft: '90px',
          // marginRight: '30px'
        }}
      >
      <SideNavComponent />
      </div>


      
      <div className='col-12 col-md-9 qx-0 px-3'
      // style={{ width: '65%', float: 'right', overflow: 'auto', paddingLeft: '50px' }}
      >
        {activeKey === '0' && (
          <>
            <div className='om-map-section'>
              <h1 id='baseMap'>Basemap</h1>
              <div className='om-map-intro'>
                <p>
                  A wide range of maps with different colour schemes were designed and created by the OneMap Team.
                  We are currently serving EPSG:3857 Coordinate System for all our maps,
                  a Spherical Mercator projection widely adopted by most map service providers. Our base maps are
                  also responsive, catering to different devices and screen sizes.
                </p>
              </div>
              <h6>You can view the demo and sample codes <a href='https://www.onemap.gov.sg/docs/maps/' target='_blank' rel='noopener noreferrer'>here</a>.</h6>

              <div className='map row justify-content-center'>
                <div className='map-thumbnail col-12 col-sm-6 col-md-3'>
                  <img className='thumbnail-map-img' alt='city' src={city} />
                 </div>
                <div className='map-thumbnail col-12 col-sm-6 col-md-3 '>
                  <img className='thumbnail-map-img' alt='night' src={night} />
                </div>
                <div className='map-thumbnail col-12 col-sm-6 col-md-3 '>
                  <img className='thumbnail-map-img' alt='grey' src={grey} />
                </div>
                <div className='map-thumbnail col-12 col-sm-6 col-md-3 '>
                  <img className='thumbnail-map-img' alt='classic' src={classic} />
                </div>
                {/* <div key={"om-section-api"} className='thumbnail col-12 col-sm-6 col-md-3 '>
                  <img className='thumbnail-img center' src={orthophoto} />
                </div> */}
              </div>
              <hr />
              <h1 id='miniMap'>Minimap</h1>
              <p>
                This Mini Map Creator tool enables users to create a mini-map on the fly with a
                marker pointing to a specified location, which can be embedded to websites as an
                iframe or served out as a hyperlink / URL.
              </p>
              <h6>You can view the tool <a href='https://www.onemap.gov.sg/tools/minimap' target='_blank' rel='noopener noreferrer'>here</a>.</h6>
              <div className='om-minimap'>
                <div className='minimap'>
                  <img className='thumbnail-minimap-img' src={minimap} alt='thumbnail-minimap' />
                </div>
              </div>
              <br /><hr />
              {/* Adv mini map */}
              <h1 id='advancedMiniMap'>Advanced Minimap</h1>
              <p>
                This Advanced Mini-Map Creator tool enables users to create a mini-map on the fly with multiple
                markers and selectable icons. The created min-map can be embedded to websites as an iframe or served out
                as a hyperlink / URL.
              </p>
              <h6>You can view the tool <a href='https://www.onemap.gov.sg/tools/amm' target='_blank' rel='noopener noreferrer'>here</a>.</h6>
              <div className='om-adv-minimap'>
                <div className='adv-minimap'>
                  <img className='thumbnail-advMap-img' src={advminimap} alt='advminimap' /><br /><br /><hr />
                </div>
              </div>
              {/* static */}
              <h1 id='staticMap'>Staticmap</h1>
              <p>
                This Static Map tool returns a static image for a map and enables users to create designated
                marker(s), line(s) and/or polygon(s) on a map. The image will be created using the generated URL
                provided for embedding in websites or print materials.
              </p>
              <h6>You can view the tool <a href='https://www.onemap.gov.sg/tools/staticmap/' target='_blank' rel='noopener noreferrer'>here</a>.</h6>
              <div className='om-staticmap'>
                <div className='staticmap'>
                  <img className='thumbnail-staticmap-img' src={staticMap} alt='thumbnail-staticmap' />
                </div>
              </div>
            </div>
            
          </>
        )}
        {activeKey === '1' && (
          <>
            <div id='om-search-section' className='om-search-section' style={{ minHeight: '510px' }}>
              <h1 style={{ fontSize: '32px' }} id='search'>Search</h1>
              <p style={{ alignItems: 'center', marginTop: '0px', marginBottom: '1rem', fontSize: '14px' }}>
                This API enables users to obtain address information for roads and buildings, etc. This API is
                great for web forms or application that can benefit from instant address verification or solutions that want
                localised POI.
                {/* This API looks up the address data for an entered value. It returns both &nbsp; */}
                {/* <code style={{ backgroundColor: '#0000000d', fontSize: '12px', fontWeight: 400, lineHeight: '25px' }}>
                  latitude, longitude
                </code>
                  &nbsp;and<code style={{ backgroundColor: '#0000000d', fontSize: '12px', fontWeight: 400, lineHeight: '25px' }}> x, y </code>
                  coordinates of the searched location. */}
              </p><br />
              <p>
                This API looks up the address data for an entered value. It returns both latitude, longitude and x,y coordinates
                of the searched location.
              </p>
              
              <div className='om-search-wrapper'>
                {/* <div className='om-search'>
                  <h4 className='om-search-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-search-items'>
                  <div className='om-search-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-search-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className='om-search-wrapper'>
                <div className='om-search'>
                  <h4 className='om-search-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-search-items'>
                  <div className='om-search-item'>
                    <div className='label-method'>
                      searchVal
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-search-desc'>
                      <p>Keywords entered by users to filter the results</p>
                    </div>
                  </div>
                  <div className='om-search-item'>
                    <div className='label-method'>
                      returnGeom
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-search-desc'>
                      <p>Values: Y, N . Enter Y if user wants the geometry value returned.</p>
                    </div>
                  </div>
                  <div className='om-search-item'>
                    <div className='label-method'>
                      getAddrDetails
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-search-desc'>
                      <p>Values: Y, N . Enter Y if user wants address details returned.</p>
                    </div>
                  </div>
                  <div className='om-search-item'>
                    <div className='label-method'>
                      pageNum
                      <span className='label-type'>
                        integer
                      </span>
                    </div>
                    <div className='om-search-desc'>
                      <p>Optional. Specifies the page to retrieve search results.</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* bef header params */}
              <Endpoint {...endpointreturn('search')}/>
            </div>
              <div className='d-flex justify-content-between' style={{ marginBottom: '20px' }}>
                <div className='d-flex justify-content-start'>
                  <Button
                    onClick={() => {
                      clickButton('0')
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      })
                    }}
                    style={{
                      backgroundColor: '#FFFFFF',
                      color: '#000000',
                      border: 'none',
                    }}
                  >
                    <div className='d-flex align-items-center'>
                      <img src={arrowleft} alt='arrowleft' style={{ color: '#1978FF', marginRight: '10px' }} /><b>Map Services</b>
                    </div>
                  </Button>
                </div>
                <div className='d-flex justify-content-end'>
                  <Button
                    onClick={() => {
                      clickButton('2')
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      })
                    }}
                    style={{
                      backgroundColor: '#FFFFFF',
                      color: '#000000',
                      border: 'none',
                    }}
                  >
                    <b>Authentication</b> <img src={arrowright} alt='arrowright' style={{ color: '#1978FF', marginRight: '10px' }} />
                  </Button>
                </div>
              </div>
          </>
        )}
        {activeKey === '2' && (
          <AuthenticationComponent clickButton={clickButton} endpointreturn={endpointreturn} />
        )}
        {activeKey === '3' && (
          <>
            <div id='reverseGeocode' className='om-reverseGeocode-section'>
              <h1>Reverse Geocode</h1>
              <div className='om-reverseGeocode-intro'>
                {/* <p>
                  Use Reverse Geocode when you have a location (X/Y) and need a corresponding address or road name for that
                  location. It can be used to show the location details of tracked assets.
                </p> */}
                <p>
                  The API retrieves an address that lies within a specified buffer/radius of a specified location (in latitude/longitude under WGS84 coordinates or Y/X under SVY21 coordinates).
                </p>
                <p>
                  The maximum buffer/radius is 500m for buildings and 20m for roads. Fields without value will return as "NIL".
                  Building name will return "null", if the building is not named. Longer response time is expected for searching of
                  some addresses. By default, the system will return a maximum of 10 nearest buildings.
                </p>
                <p>
                  Reverse Geocode is available in SVY21 and WGS84 format.
                </p>
              </div>
              <h4 id='svy21'>Reverse Geocode(SVY21)</h4>
              <h3 className='om-reverseGeocode-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <p>400 - Please send the access token in the request header as a bearer token.</p>
              <p>400 - Your provided location is empty.</p>
              <p>400 - Your provided location is invalid.</p>
              <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
              <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
              <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
              <p>429 - API limit(s) exceeded.</p>
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>QUERY PARAMETERS</h4>
                </div>
                
                <div className='om-reverseGeocode-items'>
                <div className='om-reverseGeocode-item'>
                  <div className='label-method'>
                    location
                    <span className='label-type'>
                      string
                    </span>
                  </div>
                  <div className='om-reverseGeocode-desc'>
                    <p>Latitude and Longitude Coordinates in SVY21 format.</p>
                  </div>
                </div>
                <div className='om-reverseGeocode-item'>
                  <div className='label-method'>
                    buffer
                    <span className='label-type'>
                      string
                    </span>
                  </div>
                  <div className='om-reverseGeocode-desc'>
                    <p>
                      Optional. Values: 0-500 (in meters).
                      Rounds up all buildings in a circumference from a point and search building add
                    </p>
                  </div>
                </div>
                <div className='om-reverseGeocode-item'>
                  <div className='label-method'>
                    addressType
                    <span className='label-type'>
                      string
                    </span>
                  </div>
                  <div className='om-reverseGeocode-desc'>
                  <p>
                      Optional. Values: HDB or All. Allows users to define property types within the buffer/radius. If HDB is selected, result
                    </p>
                  </div>
                </div>
                <div className='om-reverseGeocode-item'>
                  <div className='label-method'>
                    otherFeatures
                    <span className='label-type'>
                      string
                    </span>
                  </div>
                  <div className='om-reverseGeocode-desc'>
                    <p>
                      Optional. Values: Y or N. Allows uses the page to retrieve information on reservoirs, playgrounds,
                      jetties, etc. Default is N.
                    </p>
                  </div>
                </div>
              </div>
              </div>
                <Endpoint {...endpointreturn('revgeocodexy')} />
                <h4 id='wgs84'>Reverse Geocode(WGS84)</h4>
              </div>
              <h3 className='om-reverseGeocode-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <p>400 - Please send the access token in the request header as a bearer token.</p>
              <p>400 - Your provided location is empty.</p>
              <p>400 - Your provided location is invalid.</p>
              <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
              <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
              <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
              <p>429 - API limit(s) exceeded.</p>
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
            <div className='om-reverseGeocode-wrapper'>
              <div className='om-reverseGeocode'>
                <h4 className='om-reverseGeocode-header'>QUERY PARAMETERS</h4>
                {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
              </div>
              <div className='om-reverseGeocode-items'>
                <div className='om-reverseGeocode-item'>
                  <div className='label-method'>
                    location
                    <span className='label-type'>
                      string
                    </span>
                  </div>
                  <div className='om-reverseGeocode-desc'>
                    <p>Latitude and longitude coordinates in WGS84 format.</p>
                  </div>
                </div>
                <div className='om-reverseGeocode-item'>
                  <div className='label-method'>
                    buffer
                    <span className='label-type'>
                      string
                    </span>
                  </div>
                  <div className='om-reverseGeocode-desc'>
                    <p>
                      Optional. Values: 0-500 (in meters).
                      Rounds up all buildings in a circumference from a point and search building add
                    </p>
                  </div>
                </div>
                <div className='om-reverseGeocode-item'>
                  <div className='label-method'>
                    addressType
                    <span className='label-type'>
                      string
                    </span>
                  </div>
                  <div className='om-reverseGeocode-desc'>
                  <p>
                      Optional. Values: HDB or All. Allows users to define property types within the buffer/radius. If HDB is selected, result
                    </p>
                  </div>
                </div>
                <div className='om-reverseGeocode-item'>
                  <div className='label-method'>
                    otherFeatures
                    <span className='label-type'>
                      string
                    </span>
                  </div>
                  <div className='om-reverseGeocode-desc'>
                    <p>
                      Optional. Values: Y or N. Allows uses the page to retrieve information on reservoirs, playgrounds,
                      jetties, etc. Default is N.
                    </p>
                  </div>
                </div>
              </div>
            </div>
              <Endpoint {...endpointreturn('revgeocode')} />
            <div className='d-flex justify-content-between' style={{ marginBottom: '20px' }}>
              <div className='d-flex justify-content-start'>
                <Button
                  onClick={() =>{
                    clickButton('2')
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      })
                  }}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    border: 'none',
                  }}
                >
                  <div className='d-flex align-items-center'>
                    <img src={arrowleft} alt='arrowleft' style={{ color: '#1978FF', marginRight: '10px' }} /><b>Authentication</b>
                  </div>
                </Button>
              </div>
              <div className='d-flex justify-content-end'>
                <Button
                  onClick={() => {
                    clickButton('4')
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    })
                  }}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    border: 'none',
                  }}
                >
                  <b>Routing</b> <img src={arrowright} alt='arrowright' style={{ color: '#1978FF', marginRight: '10px' }} />
                </Button>
              </div>
              
            </div>
          </>
        )}
        {activeKey === '4' && (
          <>
            <div id='om-routing-section' className='om-routing-section'>
              <h1 id='routing'>Routing</h1>
              <div className='om-routing-intro'>
                <p>
                  OneMap has different routing options localised for commuting in Singapore. They include, public transport
                  (PT), drive, walk and cycle.
                </p>
                <p>
                  This API includes calculating the distance for the path, and returning the drawn path
                  between the specified start and end positions depending on the routeType.
                </p>
                <p>
                  Response for total time is in seconds and total distance is in metres.
                </p>
                <p>
                  Return responses have a route_geometry variable that is encoded. Users must use the sample code given if
                  drive or walk is selected (see <a href='https://developers.google.com/maps/documentation/utilities/polylineutility'>Decoding route geometry</a>).
                </p>
              </div>
              <h1 id='publicTransport'>Public Transport</h1>
              <p>
                This API retrieves travel paths involving public transports. If <strong className='slate-bold'>routeType</strong> parameter is
                set to <strong className='slate-bold'>pt</strong>, users are able to choose between 3 modes of public transport. More input
                parameters (date, time, and mode) will be required for <strong className='slate-bold'>pt</strong>.
              </p>
              <p>
                Parameter <strong className='slate-bold'>maxWalkDistance</strong> is the maximum walking distance. Parameter
                numItineraries may be used to limit the number of results returned.  
              </p>
              {/* <p>Do not include these parameters if walk or drive is specified as the <strong className='slate-bold'>routeType</strong>.</p> */}
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p>400 - Please send the access token in the request header as a bearer token.</p>
                <p>400 - Please input both latitude and longitude coordinates.</p>
                <p>400 - Date format should be in MM-DD-YYYY.</p>
                <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-cc-wrapper'>
                <div className='om-cc'>
                  <h4 className='om-cc-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-cc-items'>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-cc-wrapper'>
                <div className='om-cc'>
                  <h4 className='om-cc-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-cc-items'>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      start
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>The start point in WGS84 latitude, longitude format.</p>
                    </div>
                  </div>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      end
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>The end point in WGS84 latitude, longitude format.</p>
                    </div>
                  </div>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      routeType
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>Route types available walk, drive, pt, and cycle. Only lowercase is allowed.</p>
                    </div>
                  </div>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      date
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>Date of the selected start point in MM-DD-YYYY.</p>
                    </div>
                  </div>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      time
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>
                        Time of the selected start point in [HH][MM][SS], using the 24-hour clock system. [HH] refers to
                        a zero-padded hour between 00 and 23. [MM] refers to a zero-padded minute between 00 and 59. [SS] refers to a zero-padded second between 00 and 59.
                      </p>
                    </div>
                  </div>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      mode
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>Mode of public transport: TRANSIT, BUS, RAIL. Entry must be specified in UPPERCASE</p>
                    </div>
                  </div>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      maxWalkDistance
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>Optional. The maximum walking distance set by the user in metres.</p>
                    </div>
                  </div>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      numItineraries
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>Optional. Limits the number of return results: 1 to 3.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('routePublic')} />
              <h1 id='walkdrivecycle'>Walk/Drive/Cycle</h1>
              <p>
                This API retrieves walking, driving or cycling path options for given start and end latitudes and longitudes and setting <code className='slate-code'>routeType</code> to walk, drive or cycle.
              </p>
              <h3 className='om-cc-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p>400 - Please send the access token in the request header as a bearer token.</p>
                <p>400 - Your starting/ending location is not provided.</p>
                <p>400 - Please specify a route type.(drive/pt/walk/cycle).</p>
                <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-cc-wrapper'>
                <div className='om-cc'>
                  <h4 className='om-cc-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-cc-items'>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      start
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>The start point in WGS84 latitude, longitude format.</p>
                    </div>
                  </div>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      end
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-cc-desc'>
                      <p>The end point in WGS84 latitude, longitude format.</p>
                    </div>
                  </div>
                  <div className='om-cc-item'>
                    <div className='label-method'>
                      routeType
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-routing-desc'>
                      <p>Route types available walk, drive, pt, and cycle. Only lowercase is allowed.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('routeWalk')} />
            </div>
            <div className='d-flex justify-content-between' style={{ marginBottom: '20px' }}>
              <div className='d-flex justify-content-start'>
                <Button
                  onClick={() => {
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth',
                    })
                    clickButton('3')
                  }}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    border: 'none',
                  }}
                >
                  <div className='d-flex align-items-center'>
                    <img src={arrowleft} alt='arrowleft' style={{ color: '#1978FF', marginRight: '10px' }} /><b>Reverse Geocode</b>
                  </div>
                </Button>
              </div>
              <div className='d-flex justify-content-end'>
                <Button
                  onClick={() => {
                    clickButton('5')
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    })
                  }}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    border: 'none',
                  }}
                >
                  <div className='d-flex align-items-center'>
                    <b>Coordinate Converters</b> <img src={arrowright} alt='arrowright' style={{ color: '#1978FF', marginRight: '10px' }} />
                  </div>
                </Button>
              </div>
            </div>
          </>
        )}
        {activeKey === '5' && (
          <>
            <div className='om-cc-section'>
              <h1>Coordinate Converters</h1>
              <div className='om-cc-intro'>
                <p>
                  This API provides coordinates between EPSG 3414 (SVY21),
                  EPSG 3857 and EPSG 4326 (WGS84) formats.
                </p>
              </div>
              <br /><hr />
              <h1 id='conv4326to3857'>4326(WGS84) to 3857</h1>
              <p>This API converts coordinates from EPSG:4326 to EPSG:3857.</p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p>400 - Please send the access token in the request header as a bearer token.</p>
                <p>400 - Please input both latitude and longitude coordinates.</p>
                <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      latitude
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>Latitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      longitude
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>Longitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('4326to3857')} />
              <h1 id='conv4326to3414'>4326(WGS84) to 3414(SVY21)</h1>
              <p>This API converts coordinates from EPSG:4326 to EPSG:3414.</p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p>400 - Please send the access token in the request header as a bearer token.</p>
                <p>400 - Please input both latitude and longitude coordinates.</p>
                <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      latitude
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>Latitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      longitude
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>Longitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('4326to3414')} />
              <h1 id='conv3414to3857'>3414(SVY21) to 3857</h1>
              <p>This API converts coordinates from EPSG:3414 to EPSG:3857.</p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p>400 - Please send the access token in the request header as a bearer token.</p>
                <p>400 - Please input both Y and X coordinates.</p>
                <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Y
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>Y coordinates in SVY21 format.</p>
                    </div>
                  </div>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      X
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>X coordinates in SVY21 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('3414to3857')} />
              <h1 id='conv3414to4326'>3414(SVY21) to 4326(WGS84)</h1>
              <p>This API converts coordinates from EPSG:3414 to EPSG:4326</p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p>400 - Please send the access token in the request header as a bearer token.</p>
                <p>400 - Please input both Y and X coordinates.</p>
                <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Y
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>Y Coordinates in SVY21 format.</p>
                    </div>
                  </div>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      X
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>X Coordinates in SVY21 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('3414to4326')} />
              <h1 id='conv3857to3414'>3857 to 3414(SVY21)</h1>
              <p>This API converts coordinates from EPSG:3857 to EPSG:3414</p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p>400 - Please send the access token in the request header as a bearer token.</p>
                <p>400 - Please input both Y and X coordinates.</p>
                <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Y
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>Y Coordinates in SVY21 format.</p>
                    </div>
                  </div>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      X
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>X Coordinates in SVY21 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('3857to3414')} />
              <h1 id='conv3857to4326'>3857 to 4326(WGS84)</h1>
              <p>This API converts coordinates from EPSG:3857 to EPSG:4326</p>
              <h3 className='om-cc-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p>400 - Please send the access token in the request header as a bearer token.</p>
                <p>400 - Please input both Y and X coordinates.</p>
                <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-reverseGeocode-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-reverseGeocode-items'>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      Y
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>Y coordinates in SVY21 format.</p>
                    </div>
                  </div>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      X
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>X coordinates in SVY21 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('3857to4326')} />
              <div className='d-flex justify-content-between'>
                <div className='d-flex justify-content-start'>
                  <Button
                    onClick={() => {
                      clickButton('4')
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      })
                    }}
                    style={{
                      backgroundColor: '#FFFFFF',
                      color: '#000000',
                      border: 'none',
                    }}
                  >
                    <div className='d-flex align-items-center'>
                      <img src={arrowleft} alt='arrowleft' style={{ color: '#1978FF', marginRight: '10px' }} /><b>Routing</b>
                    </div>
                  </Button>
                </div>
                <div className='d-flex justify-content-end'>
                  <Button
                    onClick={() => {
                      clickButton('6')
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      })
                    }}
                    style={{
                      backgroundColor: '#FFFFFF',
                      color: '#000000',
                      border: 'none',
                    }}
                  >
                    {/* <div className='d-flex align-items-center'> */}
                      <b>Themes</b> <img src={arrowright} alt='arrowright' style={{ color: '#1978FF', marginRight: '10px' }} />
                    {/* </div> */}
                  </Button>
                </div>
              </div>
            </div>
           </>
        )}
        {activeKey === '6' && (
          <>
            <div className='om-theme-section'>
              <h1>Themes</h1>
              <div className='om-theme-intro'>
                <p>
                  OneMap has over 100 thematic layers that users can retrieve via API. These thematic layers are provided by
                  various government agencies. Use this API for location analysis or developing applications that bring out the
                  livability of an area.
                </p>
              </div>
              <hr />
              <h1 id='checkThemeStatus'>Check Theme Status</h1>
              <p>This API checks if the themes are updated.</p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <p>400 - Please send the access token in the request header as a bearer token.</p>
              <p>400 - There is no query name.</p>
              <p>400 - Your date provided is empty.</p>
              <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
              <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
              <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
              <p>429 - API limit(s) exceeded.</p>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-theme-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      queryName
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Query name. Themes’ query names can be retrieved using Get All Themes Info service.</p>
                    </div>
                  </div>
                  <div className='om-reverseGeocode-item'>
                    <div className='label-method'>
                      dateTime
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>The datetime in YYYY-MM-DDTHH:MM:SS:FFFZ. EG: 2023-06-15T16:00:00.000Z format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('checkThemeStatus')} />
              <h1 id='getThemesInfo'>Get Theme Info</h1>
              <p>
                This API searches themes with queryName and returns the themes' info.
              </p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <p>400 - Please send the access token in the request header as a bearer token.</p>
              <p>400 - There is no query name</p>
              <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
              <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
              <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
              <p>429 - API limit(s) exceeded.</p>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      queryName
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Enables users to retrieve theme information. Themes' query names can be retrieved using Get All Themes Info service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('getThemeInfo')} />
              <h1 id="getAllThemesInfo">Get All Themes Info</h1>
              <p>
                This API retrieves and returns a list of all available themes.
              </p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <p>400 - Please send the access token in the request header as a bearer token.</p>
              <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
              <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
              <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
              <p>429 - API limit(s) exceeded.</p>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      moreInfo
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Optional. Values: Y, N. Returns more information of themes such as icon names, category names, and theme owners if set as Y. Default is N.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('getAllThemesInfo')} />
              <h1 id='retrieveTheme'>Retrieve Theme</h1>
              <p>
                This API searches and returns specified list of themes that are filtered by the search term.
              </p>
              <p>
                The icon is located at <a href='https://www.onemap.gov.sg/images/themesIcon/'>https://www.onemap.gov.sg/images/themesIcon/</a><code className='slate-code'>&#123;icon name &#125;.&#123;file extension&#125;</code> 
              </p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <p>400 - Please send the access token in the request header as a bearer token.</p>
              <p>400 - There is no query name</p>
              <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
              <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
              <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
              <p>429 - API limit(s) exceeded.</p>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      queryName
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Enables users to retrieve theme information. Themes' query names can be retrieved using Get All Themes Info service.</p>
                    </div>
                  </div>
                  {/* <div className='om-theme-item'>
                    <div className='label-method'>
                      dateTime
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>The datetime in YYYY-MM-DDTHH:MM:SS:FFFZ. EG: 2015-02-10T16:00:00.000Z format.</p>
                    </div>
                  </div> */}
                </div>
              </div>
                <Endpoint {...endpointreturn('retrieveTheme')} />
              <h1 id='retrieveThemeExtent'>Retrieve Theme - With Extents</h1>
              <p>
                This API searches and returns specified list of themes that are filtered by the search term within the specified boundary
              </p>
              <h3 className='om-theme-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <p>400 - Please send the access token in the request header as a bearer token.</p>
              <p>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
              <p>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
              <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
              <p>429 - API limit(s) exceeded.</p>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>QUERY PARAMETERS</h4>
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      queryName
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                  </div>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      extents
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-reverseGeocode-desc'>
                      <p>Optional. Boundary provided by user. EG: 1.291789,103.7796402,1.3290461,103.8726032</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn('retrieveThemeExtent')} />
              <div className='d-flex justify-content-between' style={{ marginBottom: '20px' }}>
              <div className='d-flex justify-content-start'>
                <Button
                  onClick={() => {
                    clickButton('5')
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    })
                  }}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    border: 'none',
                  }}
                >
                  <div className='d-flex align-items-center'>
                    <img src={arrowleft} alt='arrowleft' style={{ color: '#1978FF', marginRight: '10px' }} /><b>Coordinate Converters</b>
                  </div>
                </Button>
              </div>
              <div className='d-flex justify-content-end'>
                <Button
                  onClick={() => {
                    clickButton('7')
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    })
                  }}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    border: 'none',
                  }}
                >
                  <b>Planning Area</b> <img src={arrowright} alt='arrowright' style={{ color: '#1978FF', marginRight: '10px' }} />
                </Button>
              </div>
            </div>
            </div>
          </>
        )}
        {activeKey === '7' && (
          <>
            <div className='om-planning-section'>
              <h1 id='planningArea'>Planning Area</h1>
              <div className='om-planning-intro'>
                <p>
                  Users will be able to get the list of the 55 planning areas in Singapore delineated by the Urban Redevelopment
                  Authority (URA). This is helpful for users who want to develop geospatial analytics solutions.
                </p>
              </div>
              <br />
              <h2 id='planningArea'>Planning area polygons</h2>
                <div className='om-planning-area'>
                <p>
                  This API retrieves all planning area polygons of Singapore in JSON format. Users could enter specified year to get planning area polygons as
                  accordingly. If not specified, api retrieves polygon results for latest master plan year.
                </p>
              </div>
              <h3 className='om-planning-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p className='slate-p'>400 - Please send the access token in the request header as a bearer token.</p>
                <p className='slate-p'>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p className='slate-p'>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p className='slate-p'>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p className='slate-p'>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-planning-wrapper'>
                <div className='om-planning'>
                  <h4 className='om-planning-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-planning-items'>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-planning-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>QUERY PARAMETERS</h4>
                  {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      year
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Optional.  If not specified, the latest data will be provided. Else, values available are 1998, 2008, 2014, and 2019.</p>
                    </div>
                  </div>
                </div>
              </div>
                <Endpoint {...endpointreturn('getPlanningareaPoly')} />

                <h2 id='namesofPlanningArea'>Names of planning area</h2>
                <div className='om-planning-area'>
                <p>
                  This API retrieves the names of all planning areas in Singapore for given year.
                </p>
              </div>
              <h3 className='om-planning-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p className='slate-p'>400 - Please enter valid year.</p>
                <p className='slate-p'>400 - Please send the access token in the request header as a bearer token.</p>
                <p className='slate-p'>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p className='slate-p'>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p className='slate-p'>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p className='slate-p'>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-planning-wrapper'>
                <div className='om-planning'>
                  <h4 className='om-planning-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-planning-items'>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-planning-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='om-theme-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>QUERY PARAMETERS</h4>
                  {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
                </div>
                <div className='om-theme-items'>
                  <div className='om-theme-item'>
                    <div className='label-method'>
                      year
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Optional.  If not specified, the latest data will be provided. Else, values available are 1998, 2008, 2014, and 2019.</p>
                    </div>
                  </div>
                </div>
              </div>
                <Endpoint {...endpointreturn('getPlanningareaNames')} />


              <h1 id='planningAreaQuery'>Planning Area Query</h1>
              <div>
                <p>
                  This API retrieves one planning area polygon based on given latitude and longitude.
                </p>
              </div>
              <h3 className='om-planning-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p className='slate-p'>400 - Please send the access token in the request header as a bearer token.</p>
                <p className='slate-p'>400 - Your latitude input is invalid.</p>
                <p className='slate-p'>400 - Your longitude input is invalid.</p>
                <p className='slate-p'>400 - Both your latitude and longitude are missing.</p>
                <p className='slate-p'>401 - Token has expired: Session expired. Please refresh your token (if still within refresh window) or re-login.</p>
                <p className='slate-p'>401 - Invalid token: Could not decode token: The token xxx; is an invalid JWS.</p>
                <p className='slate-p'>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>
                <p className='slate-p'>429 - API limit(s) exceeded.</p>
              </div><br />
              <div className='om-planning-wrapper'>
                <div className='om-reverseGeocode'>
                  <h4 className='om-reverseGeocode-header'>HEADER PARAMETERS</h4>
                </div>
                <div className='om-planning-items'>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      Authorization
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-planning-desc'>
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='om-planning-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>QUERY PARAMETERS</h4>
                  {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
                </div>
                <div className='om-planning-items'>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      latitude
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>This represents the latitude of the point.</p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      longitude
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>This represents the longitude of the point.</p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      year
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Optional. If not specified, the latest data will be provided. Else, values available are 1998, 2008, 2014, and 2019.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Endpoint {...endpointreturn('getPlanningarea')} />
            <br />
            <div className='d-flex justify-content-between' style={{ marginBottom: '20px' }}>
              <div className='d-flex justify-content-start'>
                <Button
                  onClick={() => {
                    clickButton('6')
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      })
                  }}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    border: 'none',
                  }}
                >
                  <div className='d-flex align-items-center'>
                    <img src={arrowleft} alt='arrowleft' style={{ color: '#1978FF', marginRight: '10px' }} /><b>Themes</b>
                  </div>
                </Button>
              </div>
              <div className='d-flex justify-content-end'>
                <Button
                  onClick={() => {
                    clickButton('8')
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth'
								    })
                  }}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    border: 'none',
                  }}
                >
                  <div className='d-flex align-items-center'>
                    <b>Population Query</b> <img src={arrowright} alt='arrowright' style={{ color: '#1978FF', marginLeft: '10px' }} />
                  </div>
                </Button>
              </div>
            </div>
          </>
        )}
        {activeKey === '8' && (
          <PopulationComponent clickButton={clickButton} endpointreturn={endpointreturn} />
        )}
        {activeKey === '9' && (
          <>
            <div className='om-planning-section'>
              <h1 id='getStaticMap'>Static Map</h1>
              <p>
                This API returns a static image of a map based on the defined parameters in PNG format which users may overlay multiple point(s), polygon(s), or polyline(s) on the map
                <br /><br />
                Users can also create personalised static maps via the <a href='https://www.onemap.gov.sg/tools/staticmap/' target='_blank' rel='noopener noreferrer'>Static Map Creator</a>
              </p>
              <br />
              <h3 className='om-planning-err'>
                <strong className='slate-bold'>Possible Error Responses</strong>
              </h3>
              <div>
                <p className='slate-p'>400 - Please select a valid map style</p>
                <p className='slate-p'>400 - Please enter a valid zoom level</p>
                <p className='slate-p'>400 - Please enter a pair of valid width and height(in pixels).</p>
                <p className='slate-p'>400 - The maximum resolution size is 512 x 512.</p>
                <p className='slate-p'>400 - Please enter a pair of valid latitude & longitude.</p>
              </div><br />

              <div className='om-planning-wrapper'>
                <div className='om-theme'>
                  <h4 className='om-theme-header'>QUERY PARAMETERS</h4>
                  {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
                </div>
                <div className='om-planning-items'>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      layerchosen
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Choice of available base maps: night, grey, original, default and landlot</p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      latitude
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Latitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      longitude
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Longitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      postal
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Either latitude/longitude or postal should be used.</p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      zoom
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Values: 11- 19. The zoom level of the static image. The lower the value, the more zoomed out the static image.</p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      width
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Values: 128- 512. The width of the static image.</p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      height
                      <span className='label-type'>
                        string
                      </span>
                      <span className='label-required'>
                        Required
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>Values: 128- 512. The height of the static image.</p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      polygons
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>
                        Coordinates of polygon(s) to be overlaid on the base map.
                        Polygon(s) and its color are segregated by semicolon.
                        Whereas each polygon is differentiated with a pipe.
                        The start and end must be of the same point but all other points should be unique.
                      </p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      lines
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>
                        Coordinates of line(s) to be overlaid on the base map.
                        Line(s), its color, and thickness are segregated by semicolon.
                        Each line is differentiated with a pipe.
                      </p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      points
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>
                        Coordinates of point(s) to be overlaid on the base map.
                        Coordinates of individual point are segregated with a comma.
                        Each point is differentiated with a pipe. This is an example of 2 points differentiated with pipe,
                        [1.31955,103.84223,"255,255,178"]|[1.31801,103.84224,"175,50,0"]
                      </p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      color
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>
                        Specifies the color of all lines. Color must be in RGB format. EG: 255, 0, 255.
                      </p>
                    </div>
                  </div>
                  <div className='om-planning-item'>
                    <div className='label-method'>
                      fillColor
                      <span className='label-type'>
                        string
                      </span>
                    </div>
                    <div className='om-theme-desc'>
                      <p>
                        Specifies the fill color of all polygons. Color must be in RGB format. EG: 0, 255, 0.
                      </p>
                    </div>
                  </div><br />
                  {/* <img src={staticmapImg} alt='staticmapImg' /> */}
                </div>
              </div>
            </div>
            <Endpoint {...endpointreturn('staticMap')} />
              {/* <img src={staticmapImg} alt='staticmapImg' /> */}
              <br />
            <div className='d-flex justify-content-between' style={{ marginBottom: '20px' }}>
              <div className='d-flex justify-content-start'>
                <Button
                  onClick={() => {
                    clickButton('8')
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      })
                  }}
                  style={{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    border: 'none',
                  }}
                >
                  <div className='d-flex align-items-center'>
                    <img src={arrowleft} alt='arrowleft' style={{ color: '#1978FF', marginRight: '10px' }} /><b>Population Query</b>
                  </div>
                </Button>
              </div>
            </div>
          </>
        )}
      </div>

      </div>
      <FooterComponent />
    </>
  )
}
export default MapsServices